import { graphql } from 'gatsby';
import useLinkProps from '@/components/Link/hooks/useLinkProps';
import CloseIcon from '@/components/Icon/components/CloseIcon/CloseIcon';
import {
  StyledLink,
  StyledInformationStripe,
  StyledTitle,
  Wrapper,
  CloseButtonWrapper,
} from './InformationStripe.styles';

type InformationStripeProps = Queries.HEADER_INFORMATION_STRIPEFragment & {
  onClose: () => void;
};

const InformationStripe = ({ elements, onClose }: InformationStripeProps) => {
  const { title, link } = elements;
  const linkElements = link?.value?.linkElements;

  const { linkChildren, linkProps } = useLinkProps({
    action: linkElements?.action.value,
    target: linkElements?.target?.value,
  });

  const hasLinkText = typeof linkElements?.text.value === 'string';

  return (
    <StyledInformationStripe data-block-information-stripe>
      <Wrapper>
        <CloseButtonWrapper onClick={onClose}>
          <CloseIcon variant="close_icon_basic_light" />
        </CloseButtonWrapper>
        <StyledTitle>{title.value}</StyledTitle>
        {hasLinkText && (
          <StyledLink {...linkProps}>
            {linkChildren}
            {linkElements.text.value}
          </StyledLink>
        )}
      </Wrapper>
    </StyledInformationStripe>
  );
};

export const fragment = graphql`
  fragment HEADER_INFORMATION_STRIPE on kontent_item_header_information_stripe {
    elements {
      title {
        value
      }
      link {
        value {
          ...LINK
        }
      }
    }
  }
`;

export default InformationStripe;
